// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DjtU8","requiredAsterisk":"Info_requiredAsterisk__3BRDy"};